import React from 'react';
import clsx from 'clsx';

import { Skeleton } from '../components';
import { Tab } from '../../../components';
import { useLocalize } from '../../../hooks';
import { TabNames, TabLabels } from '../const';
import { PageLayout } from '../../../app/Layouts';
import type { LayoutProps } from './Desktop';

export const MobileLayout: React.FC<LayoutProps> = ({
  title,
  tabs,
  quiz,
  video,
  jessica,
  navigation,
  nextButton,
  breadcrumbs,

  loading,
  stepDetails,
}) => {
  const { t } = useLocalize();

  return (
    <PageLayout
      subheaderContent={
        <div className="py-md px-md flex flex-row justify-between items-center gap-x-lg">
          {breadcrumbs} {nextButton}
        </div>
      }
    >
      <>
        {jessica}

        <div
          className={clsx(
            !loading ? 'overflow-y-scroll' : 'overflow-hidden',
            'flex flex-row h-full w-full'
          )}
        >
          {loading ? (
            <Skeleton isMobile />
          ) : (
            <div className="px-0 flex justify-center w-full">
              <div className="max-w-[88rem] w-full flex flex-col ">
                {title}
                {stepDetails?.type !== 'QUIZ' ? (
                  <>
                    {video}
                    {React.cloneElement(tabs, {
                      className: clsx(tabs.props.className, 'px-md'),
                      tabsClassName: clsx(
                        tabs.props.tabsClassName,
                        'overflow-x-auto whitespace-nowrap'
                      ),
                      tabs: [
                        { name: TabNames.Course, label: t(TabLabels.Course) },
                        ...tabs.props.tabs,
                      ],
                      children: [
                        <Tab name={TabNames.Course} key={TabNames.Course}>
                          {navigation}
                        </Tab>,
                        ...(tabs.props.children as any),
                      ],
                    })}
                  </>
                ) : (
                  quiz
                )}
              </div>
            </div>
          )}
        </div>
      </>
    </PageLayout>
  );
};
